export interface GameSettings {
  masterVolume: number;
  sfxVolume: number;
  bgmVolume: number;
  fullscreen: boolean;
  pixelPerfect: boolean;
}

export class SettingsManager {
  private static readonly SETTINGS_KEY = 'FORGOTTEN_RUINS_SETTINGS_V1';

  private static settings: GameSettings = {
    masterVolume: 0.8,
    sfxVolume: 1.0,
    bgmVolume: 0.7,
    fullscreen: false,
    pixelPerfect: true,
  };

  public static init(): GameSettings {
    try {
      const raw = localStorage.getItem(this.SETTINGS_KEY);
      if (raw) {
        this.settings = { ...this.settings, ...JSON.parse(raw) };
      }
    } catch (e) {
      console.warn('Failed to load settings:', e);
    }
    return this.settings;
  }

  public static get(): GameSettings {
    return this.settings;
  }

  public static update(newSettings: Partial<GameSettings>): GameSettings {
    this.settings = { ...this.settings, ...newSettings };
    try {
      localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(this.settings));
    } catch (e) {
      console.error('Failed to save settings:', e);
    }
    return this.settings;
  }
}
